import { Fragment } from "react"
import HtmlParser from "react-html-parser"
import { SVOD_RAIL_BONUSES, SVOD_RAIL_TVOD, metadata } from "lacinetek-common/src/metadata"

import { Products } from "components/common"
import { BlockTitle } from "./block-title"
import { SliderRailProduct } from "./rail-products"
import { ProductCard } from "./product-card"
import { SliderRailBonus } from "./rail-bonus"

export const SliderSubscription = ({ block, className, isOverlay = false }) => {
	return (
		<section id={block.id} className={className}>
			<BlockTitle block={block} />
			{
				block.description !== ""
				&& HtmlParser(block.description)
			}
			<DisplaySliders	rails={block.children.items} isOverlay={isOverlay} />
		</section>
	)
}

export const DisplaySliders = ({ rails, isOverlay }) => {
	return rails.map(rail => {
		if (metadata(rail, SVOD_RAIL_TVOD) === "Oui") {
			return null
		}

		if (metadata(rail, SVOD_RAIL_BONUSES) !== undefined) {
			const parseIds = metadata(rail, SVOD_RAIL_BONUSES).split(",")

			if (!parseIds.length > 0) {
				return null
			}

			return (
				<Fragment key={`rail-${rail.id}`}>
					<BlockTitle
						block={rail}
						rail
					/>
					<SliderRailBonus
						bonusIds={parseIds}
					/>
				</Fragment>
			)
		}

		if (!rail.products.items.length > 0) {
			return null
		}

		if (rail.products.items.length === 1) {
			return (
				<Fragment key={`rail-single-product-${rail.id}`}>
					<BlockTitle
						block={rail}
						rail
					/>
					<Products
						products={rail.products.items}
						loading={false}
						getVideoIds
					>
						{products => <ProductCard product={products[0]} />}
					</Products>
				</Fragment>
			)
		}

		return (
			<Fragment key={`rail-${rail.id}`}>
				<BlockTitle
					block={rail}
					rail
				/>
				<SliderRailProduct
					productIds={rail.products.items}
					withPreview
					isOverlay={isOverlay}
					isSvod
				/>
			</Fragment>
		)
	})
}
